import type { paths } from '@pba/types-openapi-client';
import type { ConfigRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type GroupsQueryRequestParams = paths['/v3/groups']['get']['parameters']['query'];
type ResponseType = paths['/v3/groups']['get']['responses']['200']['content']['application/json'];

export const getGroups = async ({ config: { params } }: ConfigRequest<GroupsQueryRequestParams>) =>
  apiClient.get<ResponseType, ApiClientResponse<ResponseType>>(routes.groups.find, { params });
